import React, { useEffect, useMemo, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";

import AddonItem from "../Items/AddonItem";
import LoaderMini from "../Loader/LoaderMini";
import ScrollContainer from "react-indiana-drag-scroll";
import { fetchAddonsByCategory } from "../../redux/slices/addonsSlice";
import { useTranslation } from "react-i18next";

const AddonsList = ({
  categoryId,
  handleAddonQuantityChange,
  selectedAddons,
  handleAddonChange,
}) => {
  const dispatch = useDispatch();
  const { addonsByCategory, loading, error } = useSelector(
    (state) => state.addons
  );
const {t} = useTranslation();
  const addons = useMemo(() => addonsByCategory[categoryId] || [], [addonsByCategory, categoryId]);
  const selectedCity = useSelector((state) => state.citySelection.selectedCity);

  useEffect(() => {
    if (categoryId  && selectedCity) {
      dispatch(fetchAddonsByCategory(categoryId));
    }
  }, [dispatch, categoryId , selectedCity]);


  const containerRef = useRef(null);


  if (error)
    return (
      <div className="text-red-500 min-h-[15rem] flex items-center justify-center">
        Error: {error}
      </div>
    );

  return (
    <div className="py-2 flex w-full h-full">
      <div className="w-full relative h-full my-4 flex">
        {loading ? (
          <div className="flex items-center  justify-center w-full h-full">
            <LoaderMini color="bg-blue-500" />
          </div>
        ) : addons.length > 0 ? (
          <ScrollContainer
            innerRef={containerRef}
            draggingClassName="scroll-smooth transition-all ease-in-out"
            className="flex items-start gap-6 w-full overflow-x-auto 
              cursor-grab active:cursor-grabbing"
          >
            {addons.map((addon) => (
              <div
                key={addon?.id}
                className="flex items-center justify-center h-full 
                  rounded-2xl carousel-item cursor-auto "
              >
                <AddonItem
                  addon={addon}
                  selectedAddons={selectedAddons}
                  handleAddonChange={handleAddonChange}
                  handleAddonQuantityChange={handleAddonQuantityChange}
                />
              </div>
            ))}
          </ScrollContainer>
        ) : (
          <div className="flex items-center justify-center text-red-500">
              {t("noAddons")}
          </div>
        )}
      </div>
    </div>
  );
};

export default AddonsList;
